module.exports = __webpack_public_path__ + "img/warning-icons.e51f834f.svg";